angular.module('service-request')
    .component('clientServiceRequestsTable', {
        bindings: {
            clientId: '<',
            propertyId: '<',
            excludeIds: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/service-request/client-service-requests.html',
        controller: function ($scope, ServiceRequest, ServiceRequestService) {
            this.ServiceRequestService = ServiceRequestService;

            this.$onChanges = () => {
                this.filters = {clientId: this.clientId, propertyId: this.propertyId, excludeIds: this.excludeIds, clientFilter: 'CLIENT_OR_PROPERTY'};
                this.loadData();
            };

            this.loadData = () => {
                if (this.clientId == null && this.propertyId == null) {
                    this.page = null;
                    this.onDataLoaded({$page: this.page});
                    return;
                }
                ServiceRequest.table(this.filters).$promise.then(result => {
                    this.page = result;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                })
            };
        }
    })
